import { useState } from 'react';
import { MIN_SEATS, MAX_SEATS, MAX_BOTS } from '@estandarte/protocol';
import { useOnline } from '../store/online';
import { EraPicker } from './EraPicker';
import { AddonToggles, SeatRow } from './SeatRow';

export function Lobby() {
  const online = useOnline();
  const { lobby, mySeat, host, error } = online;
  const [copied, setCopied] = useState(false);
  if (!lobby) {
    return (
      <div className="page">
        <p className="muted">Conectando à sala…</p>
      </div>
    );
  }
  const taken = lobby.seats.map((s) => s.color);
  const bots = lobby.seats.filter((s) => s.kind === 'bot').length;
  const canStart = host && lobby.seats.length >= MIN_SEATS;

  function copy() {
    const text = lobby!.code;
    try {
      void navigator.clipboard?.writeText(text).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
    } catch {
      /* sem clipboard */
    }
  }

  return (
    <div className="page">
      <div className="row" style={{ alignItems: 'flex-end', gap: '1rem' }}>
        <div>
          <p className="sc muted" style={{ margin: 0 }}>
            Código da sala {lobby.hasPassword ? '· com senha' : ''}
          </p>
          <div className="code-box">
            <span className="num" aria-label={`Código ${lobby.code.split('').join(' ')}`}>
              {lobby.code}
            </span>
            <button className="btn small" onClick={copy}>
              {copied ? 'Copiado!' : 'Copiar'}
            </button>
          </div>
        </div>
        <span className="spacer" />
        <button
          className="btn ghost"
          onClick={() => {
            if (window.confirm('Sair da sala?')) online.leave();
          }}
        >
          Sair da sala
        </button>
      </div>
      <p className="muted">
        Compartilhe o código com os amigos. {host ? 'Você é o anfitrião: adicione bots e comece quando houver 3 ou mais lugares.' : 'Aguarde o anfitrião começar.'}
      </p>

      <div className="section-title">
        Lugares <small>{lobby.seats.length} de {MAX_SEATS}</small>
      </div>
      <div className="seats">
        {lobby.seats.map((s, i) => {
          const mine = s.id === mySeat;
          const isBot = s.kind === 'bot';
          return (
            <SeatRow
              key={s.id}
              index={i}
              seat={s}
              takenColors={taken}
              editable={{ color: mine || (host && isBot), vocation: mine || (host && isBot), difficulty: host && isBot }}
              showVocation={lobby.addons.vocations}
              onChange={(patch) => {
                if (mine) online.setSeat(patch.color, patch.vocation);
                else online.editBot(s.id, patch);
              }}
              onRemove={host && !mine ? () => online.removeSeat(s.id) : undefined}
              removeLabel={isBot ? 'Remover bot' : `Expulsar ${s.name}`}
              tags={
                <>
                  {s.isHost && <span className="tag on">anfitrião</span>}
                  {mine && <span className="tag">você</span>}
                  {!isBot && !s.connected && <span className="tag">desconectado</span>}
                </>
              }
            />
          );
        })}
      </div>
      {host && (
        <div className="row" style={{ marginTop: '0.6rem' }}>
          <button
            className="btn small"
            disabled={lobby.seats.length >= MAX_SEATS || bots >= MAX_BOTS}
            onClick={() => online.addBot('normal')}
          >
            + Bot normal
          </button>
          <button
            className="btn small"
            disabled={lobby.seats.length >= MAX_SEATS || bots >= MAX_BOTS}
            onClick={() => online.addBot('easy')}
          >
            + Bot fácil
          </button>
        </div>
      )}

      <div className="section-title">Era {!host && <small>definida pelo anfitrião</small>}</div>
      <EraPicker value={lobby.era} disabled={!host} onChange={host ? online.setEra : undefined} bossesOn={lobby.addons.bosses} />

      <div className="section-title">Add-ons {!host && <small>definidos pelo anfitrião</small>}</div>
      <AddonToggles addons={lobby.addons} disabled={!host} onChange={host ? online.setAddons : undefined} />

      {error && (
        <div className="error-box" style={{ marginTop: '1rem' }}>
          {error}
        </div>
      )}
      {host && (
        <div className="row" style={{ marginTop: '1.5rem' }}>
          <span className="spacer" />
          <span className="hint">{lobby.seats.length < MIN_SEATS ? `Faltam ${MIN_SEATS - lobby.seats.length} lugar(es).` : ''}</span>
          <button className="btn primary" disabled={!canStart} onClick={online.start}>
            Começar
          </button>
        </div>
      )}
    </div>
  );
}
